import { ApiClientError } from '@/lib/axios/client';

/**
 * What to tell the user when sending or checking a login code fails. Only the app's JSON
 * errors carry a code and a reason: the IP limiter answers in plain text, DigitalOcean
 * replaces 5xx bodies, and a 500's own body is generic.
 */
export function otpErrorMessage(error: unknown, fallback = 'Could not verify the code. Please try again.'): string {
  if (error instanceof ApiClientError) {
    if (error.code && error.message && error.status !== 500) return error.message;
    if (error.status === 429) return 'Too many requests. Please wait a minute and try again.';
  }
  return fallback;
}
